<template>
  <Modal :is-open="viewBattleModalIsOpen" :closeable="false">
    {{ translation.battle.enterSpectateKey }}
    <input
        type="password"
        v-model="battleViewID"
        placeholder="ID"
        style="width: 30%; left: 25%"
        maxlength="12"
    />
    <br/>
    <br/>

    <div style="display: flex">
      <div>Live:</div>

      <div style="padding: 3px">
        <input type="checkbox" v-model="liveView" style="zoom: 1.5"/>
      </div>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-primary"
          @click="
          viewBattle(battleViewID, liveView);
          viewBattleModalIsOpen = true;
        "
      >
        {{ translation.general.okay }}
      </button>

      <button
          type="button"
          class="btn btn-secondary"
          v-on:click="viewBattleModalIsOpen = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <Modal :is-open="SearchPopupModal" :closeable="false">
    <div>{{ translation.battle.waitForPlayer }}</div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          v-on:click="cancelSearch()"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <Modal :is-open="RejoinPopupModal" :closeable="false">
    <div>Trying to reconnect to battle...</div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          v-on:click="cancelSearch()"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>


  <Modal :is-open="SearchConfirmPopupModal" :closeable="false">
    <div v-if="isRankedMode">{{ translation.battle.wantToBattleRanked }}</div>
    <h4 v-if="isRankedMode">Requirements:</h4>
    <div v-if="isRankedMode">{{ translation.battle.rankedRequirements }}</div>
    <div v-else>{{ translation.battle.wantToBattleCasual }}</div>

    <div v-if="checked && !isRankedMode" style="margin-top: 10px">
      <input
          type="password"
          v-model="battle_password_input"
          placeholder="Password"
          style="width: 30%; left: 25%"
          maxlength="6"
      />
    </div>

    <template #footer>
      <button v-if="!isRankedMode"
              class="btn btn-link"
              style="top: 40px; margin-right: 60px"
              v-bind:title="translation.general.inventory"
              @click="checked = !checked"
      >
        <svg
            height="32px"
            version="1.1"
            viewBox="0 0 32 32"
            width="32px"
            xmlns="http://www.w3.org/2000/svg"
            class="key-password-button"
        >
          <title/>
          <desc/>
          <defs/>
          <g
              fill="none"
              fill-rule="evenodd"
              id="Page-1"
              stroke="none"
              stroke-width="1"
          >
            <g fill="#157EFB" id="icon-24-key">
              <path
                  d="M18.5324038,19.4675962 L14,24 L11,24 L11,27 L8,27 L8,30 L3,30 L3,25 L13.5324038,14.4675962 C13.1881566,13.5437212 13,12.5438338 13,11.5 C13,6.80557939 16.8055794,3 21.5,3 C26.1944206,3 30,6.80557939 30,11.5 C30,16.1944206 26.1944206,20 21.5,20 C20.4561662,20 19.4562788,19.8118434 18.5324038,19.4675962 L18.5324038,19.4675962 L18.5324038,19.4675962 Z M27,9 C27,7.34314567 25.6568543,6 24,6 C22.3431457,6 21,7.34314567 21,9 C21,10.6568543 22.3431457,12 24,12 C25.6568543,12 27,10.6568543 27,9 L27,9 Z"
                  id="key"
              />
            </g>
          </g>
        </svg>
      </button>

      <button
          type="button"
          class="btn btn-primary"
          @click="
          searchBattle(battle_password_input);
          SearchConfirmPopupModal = false;
          SearchPopupModal = true;
        "
      >
        {{ translation.general.okay }}
      </button>
      <button
          type="button"
          class="btn btn-secondary"
          @click="SearchConfirmPopupModal = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <InfoPanel
      v-model:is-open="infoPanelIsOpen"
      :current-pokemon="infoPanelCurrentPokemon"
      @pokemon-sold="
      infoPanelIsOpen = false;
      chooseSlotPopupModal = false;
      refreshView();
    "
      @pokemon-nickname-changed="nicknameChanged"
      @wonder-trade="wonderTrade"
      @usedItem="
      async () => {
        await refreshView();
        openInfoPanel(getUpdatedCurrentPokemon(infoPanelCurrentPokemon));
      }
    "
  />

  <ItemModal
      :isOpen="chooseSlotPopupModal"
      :hasInfoButton="true"
      :hasRemoveFromTeamButton="true"
      @removedFromTeam="refreshView()"
      @update:is-item-modal-open="chooseSlotPopupModal = $event"
      @update:is-pokemon-info-open="
      chooseSlotPopupModal = false;
      openInfoPanel(currentPokemon);
    "
      @usedItem="
      async () => {
        await refreshView();
        openInfoPanel(getUpdatedCurrentPokemon(currentPokemon))
      }
    "
      :pokemon="currentPokemon"
  />

  <Modal :is-open="missionRequirementsModalIsOpen" :closeable="false">
    <h3 style="text-decoration: underline">{{ challenge.title }}</h3>
    <h5>Requirements:</h5>
    <div v-for="req in challenge.requirements" :key="req">
      <div>- {{ req }}</div>
    </div>
    <br/>

    <div v-if="challenge.error" style="color: red">{{ challenge.error }}</div>
    <br/>

    <div v-if="challenge" class="col col-6 pr-0 pl-1" style="left: 25%">
      <button
          v-if="challenge.meet_requirements"
          class="btn btn-block btn-dark"
          style="padding: 15px; background-color: #dc1818"
          @click="joinBotBattle('challenge')"
      >
        Join challenge!
      </button>
    </div>

    <div v-if="challenge" class="col col-6 pr-0 pl-1" style="left: 12%">
      <button
          v-if="!challenge.meet_requirements"
          class="btn btn-block btn-dark"
          style="padding: 15px; background-color: #dc1818; width: 150%"
          :disabled="true">
        You are not meeting the requirements!
      </button>

      <br/>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="missionRequirementsModalIsOpen = false">
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>


  <Modal :is-open="battleTowerModalIsOpen" :closeable="false">
    <h3 style="text-decoration: underline">Random Battle Arena</h3>

    <div>
      Battle with random pokemon of yours in PvE battles.
    </div>

    <div v-if="battleTower.requirements.length > 0">
      <h5>Requirements:</h5>
      <div v-for="req in battleTower.requirements" :key="req">
        <div>- {{ req }}</div>
      </div>
      <br/>
    </div>

    <div v-if="battleTower.error" style="color: red">{{ battleTower.error }}</div>

    <div v-if="battleTower" class="col col-6 pr-0 pl-1" style="left: 25%">
      <button
          v-if="battleTower.meet_requirements"
          class="btn btn-block btn-dark"
          style="padding: 15px; background-color: #dc1818"
          @click="joinBotBattle('tower')">
        Battle
      </button>
      <button
          v-else
          class="btn btn-block btn-dark"
          style="padding: 15px; background-color: #dc1818;opacity:0.3;">
        Battle
      </button>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="battleTowerModalIsOpen = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <div v-if="value" :key="value">
    <Multiselect
        style="width: 80%; padding-top: 10px; margin: auto"
        v-model="value"
        :options="options"
        :show-labels="false"
        :searchable="false"
        :allow-empty="false"
        v-bind:placeholder="value.name"
        track-by="id"
        label="name"
        @close="changeActiveTeam(value)"
    />
  </div>

  <div
      v-if="value"
      style="margin-top: 10px; margin-bottom: -15px; margin-left: 10%"
  >
    <h5 @click="startEditTeamname" id="pokemonNickname">{{ value.name }}</h5>
    <input
        style="width: 60%"
        type="text"
        id="pokemonNicknameInput"
        name="pokemonName"
        class="d-none"
        v-bind:value="value.name"
        @change="updateTeamName()"
    />
  </div>

  <div class="row p-4">
    <div
        class="col-4 pokemon-list__entry"
        v-for="pokemon in allPokemon"
        v-bind:key="pokemon.id"
    >
      <PokemonEntryButton
          :pokedex-id="pokemon.pokedexId"
          :id="pokemon.id"
          :name="pokemon.name"
          :is-shiny="pokemon.isShiny"
          :sell-price="pokemon.sellPrice"
          :lvl="pokemon.lvl"
          :hpPercent="pokemon.hpPercent"
          :team-slot="pokemon.teamSlot"
          :status-effect="pokemon.statusEffect"
          :public-battle-banned="pokemon.publicBattleBanned"
          :special-variant="pokemon.specialVariant"
          @click="
          currentPokemon = pokemon;
          chooseSlotPopupModal = true;
        "
          @contextmenu.prevent="removeFromTeam(pokemon)"
      />
    </div>
  </div>

  <div style="margin:auto;width:70%;">
    <button
        class="btn btn-block btn-dark" style="margin:3px;color:white; background-color: #dc1818"
        @click="showRankingLeaderboard()">
      Leaderboard (Wins: {{ wins }} Losses: {{ loses }})
    </button>
  </div>


  <div v-if="allPokemon.length === 6">


    <div style="width:88%;margin:auto;">
      <div v-if="tourney.key !== null && tourney.in_tourney">
        <button
            class="btn btn-block btn-primary"
            style="padding: 15px;height:80px;"
            @click="searchBattle(tourney.key)">
          {{ translation.battle.searchTourneyBattle(tourney.opponent_username, tourney.round) }}
        </button>
      </div>
      <div v-if="tourney.key === null && tourney.in_tourney">
        <button
            class="btn btn-block btn-secondary"
            style="padding: 15px;height:80px;"
            disabled="disabled">
          {{ translation.battle.searchTourneyBattleNotReady(tourney.round) }}
        </button>
      </div>
    </div>


    <div style="display: flex;width:90%;margin:auto;height:60px;margin-top: 6px;">
      <button class="btn btn-dark" :style="pcgSecondaryThemeStyle" style="width:49%;margin:3px;" :disabled="!enableRankedButton"
              @click="isRankedMode=true;SearchConfirmPopupModal = true">
        {{ translation.battle.searchBattleRanked }} ({{ currentMMR }})
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M6.2,2.44L18.1,14.34L20.22,12.22L21.63,13.63L19.16,16.1L22.34,19.28C22.73,19.67 22.73,20.3 22.34,20.69L21.63,21.4C21.24,21.79 20.61,21.79 20.22,21.4L17,18.23L14.56,20.7L13.15,19.29L15.27,17.17L3.37,5.27V2.44H6.2M15.89,10L20.63,5.26V2.44H17.8L13.06,7.18L15.89,10M10.94,15L8.11,12.13L5.9,14.34L3.78,12.22L2.37,13.63L4.84,16.1L1.66,19.29C1.27,19.68 1.27,20.31 1.66,20.7L2.37,21.41C2.76,21.8 3.39,21.8 3.78,21.41L7,18.23L9.44,20.7L10.85,19.29L8.73,17.17L10.94,15Z"/>
        </svg>
      </button>

      <button class="btn btn-dark" :style="pcgSecondaryThemeStyle" style="width:49%;margin:3px;" :disabled="!enableCasualButton"
              @click="isRankedMode=false;SearchConfirmPopupModal = true">
        {{ translation.battle.searchBattleCasual }}
        <svg style="width:24px;height:24px;" viewBox="0 0 24 24">
          <path fill="currentColor" d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z"/>
        </svg>
      </button>
    </div>


    <div style="display: flex;width:90%;margin:auto;height:60px;">
      <button v-if="challenge" class="btn btn-block btn-dark"
              style="width:49%;margin:3px;color:white;background-color: #dc8e18"
              @click="missionRequirementsModalIsOpen = true">
        {{ challenge.name }}
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z"/>
        </svg>
      </button>
      <button v-else class="btn btn-block btn-dark" disabled
              style="width:49%;margin:3px;color:white;background-color: #dc8e18; opacity: 0.2;">
        No Challenge
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z"/>
        </svg>
      </button>

      <br/>


      <button v-if="battleTower"
              class="btn btn-block btn-dark" style="width:49%;margin:3px;color:white; background-color: #dc8e18"
              @click="battleTowerModalIsOpen = true">
        Stadium
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M5,3H7L10,5L7,7V8.33C8.47,8.12 10.18,8 12,8C13.82,8 15.53,8.12 17,8.33V3H19L22,5L19,7V8.71C20.85,9.17 22,9.8 22,10.5C22,11.88 17.5,13 12,13C6.5,13 2,11.88 2,10.5C2,9.8 3.15,9.17 5,8.71V3M12,9.5C8.69,9.5 7,9.67 7,10.5C7,11.33 8.69,11.5 12,11.5C15.31,11.5 17,11.33 17,10.5C17,9.67 15.31,9.5 12,9.5M12,14.75C15.81,14.75 19.2,14.08 21.4,13.05L20,21H15V19A2,2 0 0,0 13,17H11A2,2 0 0,0 9,19V21H4L2.6,13.05C4.8,14.08 8.19,14.75 12,14.75Z"/>
        </svg>
      </button>
      <button v-else disabled
              class="btn btn-block btn-dark"
              style="width:49%;margin:3px;color:white; background-color: #dc8e18; opacity: 0.2;">
        Stadium
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M5,3H7L10,5L7,7V8.33C8.47,8.12 10.18,8 12,8C13.82,8 15.53,8.12 17,8.33V3H19L22,5L19,7V8.71C20.85,9.17 22,9.8 22,10.5C22,11.88 17.5,13 12,13C6.5,13 2,11.88 2,10.5C2,9.8 3.15,9.17 5,8.71V3M12,9.5C8.69,9.5 7,9.67 7,10.5C7,11.33 8.69,11.5 12,11.5C15.31,11.5 17,11.33 17,10.5C17,9.67 15.31,9.5 12,9.5M12,14.75C15.81,14.75 19.2,14.08 21.4,13.05L20,21H15V19A2,2 0 0,0 13,17H11A2,2 0 0,0 9,19V21H4L2.6,13.05C4.8,14.08 8.19,14.75 12,14.75Z"/>
        </svg>
      </button>
      <br/>
    </div>
  </div>

  <div v-else style="width:88%;margin:auto;">
    <button
        class="btn btn-block btn-dark"
        style="padding: 15px;height:80px;color:white;background-color: #727272;opacity: 0.4"
        disabled
        @click="SearchConfirmPopupModal = true">
      <div>
        {{ translation.battle.searchBattleNotEnoguh }}
      </div>

    </button>
  </div>


  <div style="width: 15%; margin: auto; padding-top: 10px">
    <button :style="pcgSecondaryThemeStyle"
            class="btn btn-block btn-dark"
            style="padding: 5px"
            @click="viewBattleModalIsOpen = true">
      <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
        />
      </svg>
    </button>
  </div>

  <br>
  <div v-if="twitch_id === '80629581' "
       class="col col-6 pr-0 pl-1"
       style="left: 25%; margin-top: 15px">
    <button
        class="btn btn-block btn-dark"
        style="padding: 15px; background-color: #dc1818"
        @click="autoPlayBattles = true;viewBattle('13376942', false);">
      Spectate channel
    </button>
    <br/>
  </div>

</template>

<script>
import ItemModal from "../../components/ItemModal/ItemModal.vue";
import {translation} from "@/utils/translations";
import {backendUri, battleUri} from "@/utils/settings";
import axios from "axios";
import {ref} from "@vue/reactivity";
import {showModalMsg} from "@/components/Modal/modalUtils";
import Modal from "@/components/Modal/Modal";
import {battleContent, currentView} from "@/utils/globals";
import PokemonEntryButton from "@/components/PokemonEntryButton/PokemonEntryButton";
import {
  startLoadingProcess,
  stopLoadingProcess,
} from "@/components/LoadingOverlay/loadingOverlayControl";
import {onMounted} from "@vue/runtime-core";
import Battle from "@/views/Battle/Battle";
import Multiselect from "vue-multiselect";
import {handleUnknownError, sort_by} from "@/utils/utilities";
import $ from "jquery";
import {PCGApi} from "../../services/pcg";
import InfoPanel from "../PokemonList/InfoPanel";
import {pcgSecondaryThemeStyle, twitch_id, autoPlayBattles} from "../../utils/globals";
import Ranking from "../Ranking/Ranking";


export default {
  name: "BattleSlotPanel",
  components: {
    Modal,
    PokemonEntryButton,
    Multiselect,
    InfoPanel,
    ItemModal,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    currentItem: {
      type: Object,
    },
  },
  data() {
    return {
      checked: false,
    };
  },
  setup() {
    let value = ref(null);
    let options = ref([]);
    const missionRequirementsModalIsOpen = ref(false);
    const battleTowerModalIsOpen = ref(false);
    const viewBattleModalIsOpen = ref(false);
    const enableRankedButton = ref(true);
    const enableCasualButton = ref(true);

    const isRankedMode = ref(false);
    const currentMMR = ref(1000);
    const loses = ref(1000);
    const wins = ref(1000);
    const challenge = ref();
    const battleTower = ref();
    const currentPokemon = ref();
    const currentSelectedItem = ref();
    const allPokemon = ref([]);
    const tourney = ref({
      in_tourney: false,
      key: null,
      round: "Round X",
      opponent_username: null,
    });

    const joinBotBattle = async (mode) => {
      startLoadingProcess();
      await axios
          .post(battleUri + "api/game/ext/battle/search/bot/", {mode: mode})
          .then(() => {
            currentView.value = Battle;
            stopLoadingProcess();
          })
          .catch((error) => {
            if (error.response.data.error === 14) {
              showModalMsg(translation.battle.tooManyConcurrentBattles);
            } else {
              handleUnknownError(error);
            }
          });
    };

    const changeActiveTeam = async (team) => {
      await axios
          .post(backendUri + "api/game/ext/trainer/pokemon-change-active-team/", {
            team_id: team.id,
          })
          .then(() => {
            refreshView();
          })
          .catch((error) => {
            handleUnknownError(error);
          });
    };

    let nickname = ref("");
    const updateTeamName = async () => {
      nickname.value = $("#pokemonNicknameInput").val();
      await axios
          .post(
              backendUri +
              "api/game/ext/trainer/change-teamname/" +
              value.value.id +
              "/",
              {nickname: nickname.value}
          )
          .then((resp) => {
            nickname.value = resp.data.nickname;
            $("#pokemonNickname").text(nickname.value);

            value.value["name"] = nickname.value;

            $("#pokemonNickname").removeClass("d-none");
            $("#pokemonNicknameInput").addClass("d-none");
          })
          .catch((error) => {
            if (error.response.data.error === 2) {
              showModalMsg(translation.pokemonList.PokemonNicknameTooLong);
            } else {
              handleUnknownError(error);
            }
          });
    };

    const startEditTeamname = async () => {
      $("#pokemonNicknameInput").removeClass("d-none");
      $("#pokemonNickname").addClass("d-none");
    };

    const refreshView = async () => {
      startLoadingProcess();
      await axios
          .get(battleUri + "api/game/ext/battle/check_if_rejoinable/")
          .then((resp) => {
                tourney.value.in_tourney = resp.data.tourney.in_tourney;
                tourney.value.key = resp.data.tourney.key;
                tourney.value.round = resp.data.tourney.round;
                tourney.value.opponent_username = resp.data.tourney.opponent_username;

                if (resp.data.rejoinableBattle) {
                  RejoinPopupModal.value = true;
                  searchBattle('');
                }

              }
          );

      await axios
          .get(backendUri + "api/game/ext/trainer/pokemon-team-list/")
          .then((resp) => {
            allPokemon.value = resp.data.allPokemon;
            allPokemon.value.sort(sort_by("teamSlot", false));

            wins.value = resp.data.wins;
            loses.value = resp.data.loses;

            currentMMR.value = resp.data.currentMMR

            challenge.value = resp.data.challenge;

            battleTower.value = resp.data.battleTower
            enableRankedButton.value = resp.data.enableRankedButton
            enableCasualButton.value = resp.data.enableCasualButton

            options.value = [];
            for (let i = 0; i < resp.data.teamNames.length; i++) {
              options.value.push({id: i, name: resp.data.teamNames[i]});
            }
            value.value = options.value[resp.data.teamNumber];
          })
          .catch((error) => {
            handleUnknownError(error);
          });

      stopLoadingProcess();
    };

    onMounted(() => {
      refreshView();

      if (autoPlayBattles.value) {
        viewBattle("13376942", false)
      }
    });

    const removeFromTeam = async (pkm) => {
      startLoadingProcess();
      await axios
          .post(backendUri + "api/game/ext/trainer/pokemon-remove-team/", {
            pokemon_id: pkm.id,
          })
          .then(() => {
            refreshView();
          })
          .catch((error) => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.pokemonList.PokemonNotInTeam);
            } else {
              handleUnknownError(error);
            }
          });
      stopLoadingProcess();
    };

    // battle
    let chooseSlotPopupModal = ref(false);

    let SearchPopupModal = ref(false);
    let RejoinPopupModal = ref(false);
    let SearchConfirmPopupModal = ref(false);

    const cancelSearch = async () => {
      await axios
          .post(battleUri + "api/game/ext/battle/search/", {action: "cancel"})
          .then(() => {
            SearchPopupModal.value = false;
            RejoinPopupModal.value = false;
          })
          .catch((error) => {
            if (error.response.data.error === 100) {
              showModalMsg(translation.battle.userBanned + " " + error.response.data.banned_time_remaining);
            } else if (error.response.data.error === 50) {
              // Trainer currently not inside a queue!
            } else {
              handleUnknownError(error);
            }
          });
    };

    const viewBattle = async (battleViewID, liveView) => {
      if (battleViewID === undefined || battleViewID === null) {
        showModalMsg(translation.battle.battleDoesntExist);
        return;
      }
      if (battleViewID.length < 4) {
        showModalMsg(translation.battle.battleDoesntExist);
        return;
      }

      battleContent.value = {
        isViewer: true,
        liveView: liveView,
        id: battleViewID,
        speed: 5,
      };
      currentView.value = Battle;
    };

    const searchBattle = async (password) => {
      SearchPopupModal.value = true;
      const refreshBattleSearch = async (queueID) => {
        battleContent.value = {
          isViewer: false,
          speed: 0,
        };
        // break out of loop when search canceled
        if (!SearchPopupModal.value) {
          return;
        }
        await axios
            .post(battleUri + "api/game/ext/battle/search/", {
              password: password,
              queueID: queueID,
              action: "search",
              ranked: isRankedMode.value,
            })
            .then((resp) => {
              if (resp.data.started) {
                SearchPopupModal.value = false;
                currentView.value = Battle;
              } else {
                setTimeout(function () {
                  refreshBattleSearch(resp.data.queueID);
                }, 1000);
              }
            })
            .catch((error) => {
              if (error.response.data.error === 10) {
                showModalMsg(translation.battle.noTeam);
              } else if (error.response.data.error === 11) {
                showModalMsg(translation.battle.notEnoughPokemon);
              } else if (error.response.data.error === 12) {
                showModalMsg(translation.battle.TeamFainted);
              } else if (error.response.data.error === 13) {
                showModalMsg(translation.battle.bannedPokemonInTeam);
              } else if (error.response.data.error === 14) {
                showModalMsg(translation.battle.tooManyConcurrentBattles);
              } else if (error.response.data.error === 15) {
                showModalMsg(error.response.data.msg);
              } else if (error.response.data.error === 100) {
                showModalMsg(
                    translation.battle.userBanned +
                    " " +
                    error.response.data.banned_time_remaining
                );
              } else {
                handleUnknownError(error);
              }
              SearchPopupModal.value = false;
            });
      };
      refreshBattleSearch(0);
    };

    const infoPanelIsOpen = ref(false);
    const infoPanelCurrentPokemon = ref({});

    const openInfoPanel = async (pkm) => {
      startLoadingProcess();
      try {
        const pokeInfo = await PCGApi.Trainer.getTrainerPokeInfo(pkm.id);

        infoPanelIsOpen.value = true;
        infoPanelCurrentPokemon.value = {
          ...pkm,
          ...pokeInfo,
        };
      } catch (error) {
        if (error.response.data.error === 10) {
          showModalMsg(translation.pokemonList.sellNotExists);
        } else {
          handleUnknownError(error);
        }
      }

      stopLoadingProcess();
    };

    const nicknameChanged = (_id, newName) => {
      currentPokemon.value.name = newName;
    };

    const showRankingLeaderboard = () => {
      currentView.value = Ranking;
    };

    const wonderTrade = async (pokemon) => {
      chooseSlotPopupModal.value = false;
      infoPanelIsOpen.value = false;
      await refreshView();
      openInfoPanel(pokemon);
    };

    const getUpdatedCurrentPokemon = (pokemon) => {
      console.debug(pokemon)
      const instance = allPokemon.value.find((x) => x.id === pokemon.id);

      console.debug(instance);

      return instance;
    };

    return {
      refreshView,
      translation,
      SearchConfirmPopupModal,
      searchBattle,
      cancelSearch,
      removeFromTeam,
      viewBattle,
      SearchPopupModal,
      chooseSlotPopupModal,
      allPokemon,
      currentPokemon,
      changeActiveTeam,
      viewBattleModalIsOpen,
      currentSelectedItem,
      tourney,
      value,
      options,
      startEditTeamname,
      updateTeamName,
      joinBotBattle,
      challenge,
      missionRequirementsModalIsOpen,
      openInfoPanel,
      infoPanelIsOpen,
      infoPanelCurrentPokemon,
      nicknameChanged,
      wonderTrade,
      getUpdatedCurrentPokemon,
      RejoinPopupModal,
      currentMMR,
      isRankedMode,
      pcgSecondaryThemeStyle,
      battleTower,
      battleTowerModalIsOpen,
      wins,
      loses,
      autoPlayBattles,
      twitch_id,
      showRankingLeaderboard,
      enableRankedButton,
      enableCasualButton
    };
  },
};
</script>

<style lang="scss" scoped>
.pokemon-list {
  &__entry {
    padding: 0;
    margin-bottom: 20px;
  }
}

.key-password-button {
  transform: rotate(-135deg);
  transition: all 500ms ease;

  &:hover {
    transform: rotate(-45deg);
  }
}

.add-to-team {
  transition: all 600ms ease;
  transform: rotate(0deg);

  width: 68px;
  height: 68px;

  svg {
    position: absolute;
    top: 12px;
    left: 0;
    transition: all 600ms ease;
  }

  &:hover &-svg {
    transform: rotate(90deg);
  }
}
</style>
